import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {DemoDataStageType} from './constants'

const createWelcomeReducer = ({
    WELCOME = null,
}) => {
    const initialState = {
        loading: false,
        showExternalContent: false,
        demoDataStage: DemoDataStageType.IDLE,
        url: '',
        size: {
            width: 0,
            height: 0,
        },
        loadExternalWelcomeScreen: WELCOME.loadExternalWelcomeScreen,
    }

    return handleActions({
        [ActionTypes.LOADING_SET]: (state, {payload: loading}) => ({...state, loading}),
        [ActionTypes.SHOW_EXTERNAL_CONTENT_SET]: (state, {payload: showExternalContent}) => ({...state, showExternalContent}),
        [ActionTypes.DEMO_DATA_STAGE_SET]: (state, {payload: demoDataStage}) => ({...state, demoDataStage}),
        [ActionTypes.URL_SET]: (state, {payload: url}) => ({...state, url}),
        [ActionTypes.SIZE_SET]: (state, {payload: size}) => ({...state, size}),
    }, initialState)
}

export default createWelcomeReducer


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/reducer.js